<template>
  <header class="c-hitlist__header">
    <div class="c-hitlist__header__title">
      <h1 class="o-page__title">{{ title }}</h1>
      <label class="o-select" for="select-edition">
        <select class="o-select__field" id="select-edition" v-model="edition">
          <option v-for="edition in editions" :value="edition.id" :key="edition.id">{{ edition.name }}</option>
        </select>
      </label>
    </div>
    <div v-if="description" class="o-article__wrapper">
      <div class="article-body" itemprop="description">
        <p>{{ description }}</p>
      </div>
    </div>
  </header>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'Header',
    computed: {
      edition: {
        get() { return this.$store.state.hitlist.editionId },
        set(value) {
          const payload =  {
            hitlistId: this.$store.state.hitlist.hitlistId,
            editionId: value,
          };
          this.$store.dispatch('hitlist/setHitlist', payload);
        },
      },
      ...mapState({
        editions: state => state.hitlist.editions,
        title: state => state.hitlist.title,
        description: state => state.hitlist.description,
      }),
    }
  };
</script>
